import {
  StepContent as MuiStepContent,
  stepContentClasses,
  styled,
} from '@mui/material';

export const StepContent = styled(MuiStepContent)({
  [`&.${stepContentClasses.last}`]: {
    borderColor: 'transparent',
  },
});
